import React, { useRef, useState } from 'react'

import { Flex } from '@stackhouse/styled-elements'

import Modal from '@stackhouse/dashboard-components/Modal'
import Toast from '@stackhouse/dashboard-components/Toast'
import Button from '@stackhouse/dashboard-components/Button'
import { withDashboardContext } from '@stackhouse/dashboard-components/Dashboard'

import Form from '../components/ResponsiveForm'



const AttachmentModal = withDashboardContext(({ close, onSuccess, resourceId, formName, withLoader }) => {

    const fileRef = useRef(null)
    const formRef = useRef(null)

    const createFormData = (file) => {
        const data = formRef.current.getValue()

        const formData = new FormData()
        formData.append('File', file)
        formData.append('FileName', file.name)
        formData.append('IdDocumentType', data.idDocumentType || null)
        formData.append('Notes', data.notes || '')
        formData.append('FormName', formName)
        formData.append('IdKeyValue', resourceId)

        return formData
    }

    const [formValue, setFormValue] = useState({})

    const [fields] = useState({
        file: {
            group: 0,
            type: 'file',
            id: 'File',
            label: 'File',
            upload: 'none',
            required: true,
            ref: fileRef,
            createFormData,
            uploadConfig: {
                url: '/attachment/UploadDirect'
            }
        },
        idDocumentType: {
            "id": "idDocumentType",
            "type": "select",
            "label": "Document type",
            "required": false,
            "disabled": false,
            "hidden": false,
            "table": "tbl_document_types",
            "valueKey": "idnrr",
            "immediateKey": "idnrr",
            "multi": false,
            "closeOptionsOnClickAdd": true,
            "queryKeys": [
                "idnrr",
                "description"
            ],
            "columnsList": [
                "idnrr",
                "description"
            ],
            "sortable": true,
            "sort": [
                "description"
            ],
            "valueDisplayTemplate": "{{idnrr}}-{{description}}",
            "allowFilterOnEmptyQuery": true,
            "showOptionsAfterInputLength": 1,
            "limitResultRows": 0,
            "grid": {
                "isMobile": false,
                "gridType": 20,
                "defaultColumnWidth": "200",
                "borders": "columns",
                "columns": [
                    {
                        "key": "idnrr",
                        "label": "Idnrr",
                        "sticky": false,
                        "resizable": true,
                        "sortable": true,
                        "filterable": false,
                        "hidden": false,
                        "editable": false,
                        "width": "30%",
                        "dataType": "text",
                        "format": {
                            "tooltip": true
                        }
                    },
                    {
                        "key": "description",
                        "label": "Description",
                        "sticky": false,
                        "resizable": true,
                        "sortable": true,
                        "filterable": false,
                        "hidden": false,
                        "editable": false,
                        "width": "150%",
                        "dataType": "text",
                        "format": {
                            "tooltip": true
                        }
                    }
                ],
                "stickyRowIndexes": [],
                "selectedRowIndexes": [],
                "sort": [
                    "description"
                ],
                "autoHeight": false,
                "headerSticky": true,
                "columnsSortable": false,
                "alternateRows": true,
                "selectable": false,
                "exportable": true,
                "resizable": true,
                "sortSelected": false,
                "groupable": false,
                "editable": false
            },
            "group": 1,
            "fr": 1,
            "placeholder": "Document type"
        },
        notes: {
            type: 'text',
            group: 2,
            id: 'notes',
            label: 'Notes',
            multiline: true,
            rows: 4,
        },
    })

    const save = () => {
        if (formRef.current.isValid()) {
            return withLoader(done => {
                return fileRef.current.upload(
                    (response) => {
                        done()
                        close()

                        setTimeout(Toast.toast({
                            type: 'success',
                            showCloseButton: false,
                            text: `Attachment uploaded successfully.`
                        }), 3000)

                        onSuccess && onSuccess()
                    },
                    (error) => {
                        done()
                    }
                )
            })
        }
    }

    return (
        <Flex column justifyCenter p={'1em'} width={['33%', '100%', '50%']} height={[undefined, '100%']} borderRadius={[10, 0]} backgroundColor={'white'}>
            <Flex column>
                <Form ref={formRef} fields={fields} onChange={setFormValue} />
            </Flex>
            <Flex row alignCenter justifyEvenly p={10}>
                <Button flex={1} outline title={'Cancel'} onClick={close} />
                <Button flex={1} ml={'1em'} title={'Upload'} disabled={!formValue.File || !formValue.File.length} onClick={save} />
            </Flex>
        </Flex>
    )
}, ({ withLoader }) => ({ withLoader }))


export default ({ formName, resourceId, onSuccess }) => {

    return Modal.show(
        ({ close }) => (
            <AttachmentModal close={close} onSuccess={onSuccess} formName={formName} resourceId={resourceId} />
        ),
        { target: 'root', animation: 'zoom' }
    )
}